 /*=========================================================================================
  File Name: state.js
  Description: Products Actions
  ----------------------------------------------------------------------------------------
  Item Name: Products State Module
  Author: Tan Tran
==========================================================================================*/
import commands from '../../../services/products/commands.js'
import queries from '../../../services/products/queries.js'
import fileCommands from '../../../services/file/commands.js'
import ErrorHandling from '../../../common/exceptions/ErrorHandling.js'
export default {

    async getProductsAction ( { commit, state, rootState }, payload) { 
        let restaurantId = rootState.auth.auth.restaurantId;
        let token = rootState.auth.auth.token;
        let error = null;
        //console.log('action is call, id: ' + restaurantId);
        try {
            await queries.getProductsByRestaurant(restaurantId, token)
                    .then(
                        res => {
                            commit('SET_PRODUCTS_STATE', res);
                            commit('SET_CATEGORIES_STATE', res);
                        });
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    },

    async getTaxesAction ( { commit, state, rootState }, payload) {

        let restaurantId = rootState.auth.auth.restaurantId;
        let token = rootState.auth.auth.token;
        let error = null;
        //console.log('action is call, id: ' + restaurantId);
        try {
            await queries.getTaxesByRestaurant(restaurantId, token)
                     .then(
                         res => {
                             commit('SET_TAXES_STATE', res);
                        })
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
    },

    async createProductAction ( {commit, state, rootState }, payload) {

        let error = null;
        let token = rootState.auth.auth.token;

        try {
            let itemId = await commands.createItem(payload.item, token);
            let imgUrl = '';

            if (itemId != null) {
                if (payload.image != null) {
                    console.log('uploading image...');
                    let formData = new FormData();
                    formData.append('file', payload.image);
                    //let itemId = response;
                    let restaurantName = rootState.auth.auth.restaurantName;
                    let res = await fileCommands.createImageForItem(itemId, restaurantName, formData);
                    console.log(res);
                    imgUrl = res.data;
                }

                let categoryName = rootState.categories.categories.find(o => o.categoryId === payload.item.categoryId);
                let taxValue = rootState.products.taxes.find(o => o.taxId === payload.item.taxId);

                let productView = {
                    itemId : itemId,
                    itemName : payload.item.itemName,
                    description : payload.item.description,
                    originalPrice : payload.item.originalPrice,
                    estimatedTime : payload.item.estimatedTime,
                    category : categoryName,
                    categoryId : payload.item.categoryId,
                    taxId : payload.item.taxId,
                    taxValue : taxValue,
                    imageUrl : imgUrl,
                    groupOptionsJSON : payload.item.groupOptionsJSON,
                    allergiesJSON : payload.item.allergiesJSON,
                    shortName : payload.item.shortName
                };

                commit('ADD_PRODUCT_STATE', productView);
            }
        }
        catch (err) {
            console.log(err)
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    },

    async updateProductAction( { commit, state, rootState }, payload) {
        let error = null;
        let token = rootState.auth.auth.token;
        try {
            await commands.updateItem(payload.item, payload.item.itemId, token);
            let imgUrl = '';
            let restaurantName = rootState.auth.auth.restaurantName;
            if( payload.image != null) {
                console.log('uploading image...');
                let formData = new FormData();
                formData.append('file', payload.image);
                let res = await fileCommands.createImageForItem(payload.item.itemId, restaurantName, formData);
                imgUrl = res.data;
            }
            else {
                if (payload.item.imageUrl != null || payload.item.imageUrl != '') {
                    console.log('deleting image...');
                    await fileCommands.deleteImageForItem(payload.item.itemId, restaurantName);
                } 
            }
            
            let categoryName = rootState.categories.categories.find(o => o.categoryId === payload.item.categoryId);
            let taxValue = rootState.products.taxes.find(o => o.taxId === payload.item.taxId);

            let productView = {
                itemId : payload.item.itemId,
                itemName : payload.item.itemName,
                description : payload.item.description,
                originalPrice : payload.item.originalPrice,
                estimatedTime : payload.item.estimatedTime,
                category : categoryName,
                categoryId : payload.item.categoryId,
                taxId : payload.item.taxId,
                taxValue : taxValue,
                imageUrl : imgUrl,
                groupOptionsJSON : payload.item.groupOptionsJSON,
                allergiesJSON : payload.item.allergiesJSON,
                shortName : payload.item.shortName
            };
            
            commit('UPDATE_PRODUCT_STATE', productView);
        }
        catch (err) {
            console.log(err)
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        } 
    },

    async updateProductStatus({ commit, state, rootState }, payload) {

        let error = null;
        let token = rootState.auth.auth.token;
        try {
            await commands.updateItemStatus(payload,payload.itemId, token);
            commit('UPDATE_PRODUCT_STATUS_STATE', payload);
        }
        catch (err) {
            console.log(err);
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    },

    async updateProductDiscount({ commit, state, rootState }, payload) {

        let error = null;
        let token = rootState.auth.auth.token;
        try {
            console.log(payload)
            await commands.updateItemDiscount(payload,payload.itemId, token);
            commit('UPDATE_PRODUCT_DISCOUNT_STATE', payload);
        }
        catch (err) {
            console.log(err);
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    },

    async updateParentProduct( {commit, state, rootState }, payload ) {
        let error = null;
        let token = rootState.auth.auth.token;
        try {
            console.log(payload)
            await commands.updateParentItem(payload, payload.itemId, token);

            commit('UPDATE_PRODUCT_PARENT_STATE', payload);
        }
        catch (err) {
            console.log(err);
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    }

}